import React from "react";
import warningImg from "../../Assets/AuthenticationScreen/Warning.png";

interface FailurePopUpProps {
  message: string;
  onClose: () => void;
}

const FailurePopUp = ({ message, onClose }: FailurePopUpProps) => {
  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <img src={warningImg} alt="warning" style={styles.image} />
        <h2 style={styles.title}>Subscription Failed</h2>
        <p style={styles.subtitle}>{message}</p>
        <button style={styles.button} onClick={onClose}>
          Ok
        </button>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    padding: "36px 32px 28px",
    maxWidth: "340px",
    width: "90%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
  },
  image: {
    width: "90px",
    height: "90px",
    objectFit: "contain",
    marginBottom: "20px",
  },
  title: {
    fontSize: "20px",
    fontWeight: 700,
    color: "#111",
    margin: "0 0 12px",
  },
  subtitle: {
    fontSize: "14px",
    color: "#555",
    lineHeight: 1.6,
    margin: "0 0 28px",
  },
  button: {
    width: "100%",
    padding: "14px",
    backgroundColor: "#e74c3c",
    color: "#fff",
    fontSize: "16px",
    fontWeight: 600,
    border: "none",
    borderRadius: "12px",
    cursor: "pointer",
  },
};

export default FailurePopUp;
